// vittyyo wordmark (vector) with optional tagline.
export default function Logo({ size = "md", tagline = false, taglineText = "Learn From Each Other", dark = false, taglineClassName = "" }) {
  const h = size === "xl" ? "h-20 md:h-28" : size === "lg" ? "h-14 md:h-20" : size === "sm" ? "h-8" : "h-11";
  const tagColor = dark ? "#E4F0E4" : "#ffffff";
  return (
    <div className="flex flex-col items-center gap-3" data-testid="app-logo">
      <img src="/vittyyo-wordmark.svg?v=4" alt="Vittyyo" className={`${h} w-auto`} draggable={false} />
      {tagline && <p data-testid="app-logo-tagline" className={taglineClassName || "text-lg md:text-xl font-medium tracking-wide"} style={taglineClassName ? { color: "#000", WebkitTextStroke: "1px #fff" } : { color: tagColor }}>{taglineText}</p>}
    </div>
  );
}
